"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationArtNrErsatzUtil = void 0;
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const EspoolConfiguration_1 = require("./EspoolConfiguration");
class ConfigurationArtNrErsatzUtil {
    static getForIas(configuration) {
        const artNrs = this.getAllIas(configuration)
            .sortByIAIndex()
            .groupByArtNr()
            .map((g) => g.article.getQuoteArtNr())
            .filter((artNr) => {
            if (!artNr) {
                throw new Error(`${ConfigurationArtNrErsatzUtil.className}.getForIas() getQuoteArtNr retrieved undefined`);
            }
            return true;
        });
        return this.mapArtNrsToErsatzes(artNrs);
    }
    static getAllIas(configuration) {
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configuration);
        switch (type) {
            case 'Empty':
                return echain_shared_articles_oo_1.IAList.fromScratch();
            case 'Kette':
            case 'EspoolChild':
                return echain_shared_articles_oo_1.IAList.fromModel(config.IAs || []);
            case 'Espool':
                return EspoolConfiguration_1.EspoolConfiguration.fromModel(config).getIAs();
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    static mapArtNrsToErsatzes(artNrs) {
        const ersatzes = {};
        let prefixCounter = -1;
        let prefix = '';
        artNrs.forEach((artNr, i) => {
            if (!(artNr in ersatzes)) {
                ersatzes[artNr] = prefix + String.fromCharCode(65 + (i % 26));
            }
            if (i % 26 === 25) {
                prefixCounter++;
                if (prefixCounter >= 0) {
                    prefix = String.fromCharCode(65 + (prefixCounter % 26));
                }
            }
        });
        return ersatzes;
    }
}
exports.ConfigurationArtNrErsatzUtil = ConfigurationArtNrErsatzUtil;
ConfigurationArtNrErsatzUtil.className = 'ConfigurationArtNrErsatzUtil';
//# sourceMappingURL=ConfigurationArtNrErsatzUtil.js.map